import React from 'react';
import { Unity, useUnityContext } from 'react-unity-webgl';

import { isBrowser } from '../../helpers/is-browser';
import * as styles from './unity-styles.module.scss';

interface IUnityWrapperProps {
  node_locale?: string;
}

const SkeletonLoader = () => (
  <div
    className={`mb-5 aspect-0.75/1 h-auto w-full rounded-xl bg-background-primary-light ${styles.gradient}`}
  ></div>
);

const buildUrl = (
  baseURL: string,
  locale: string | undefined,
  tagId: string,
  fileType: string,
) => {
  return `${baseURL}/unity/${tagId}${
    locale ? `/${locale}` : ''
  }/Build/${tagId}.${fileType}`;
};

export const UnityWrapper = ({ node_locale }: IUnityWrapperProps) => {
  const storageUrl = process.env.GATSBY_UNITY_STORAGE_SPACE_URL || '';
  const meetingPlaceId =
    process.env.GATSBY_MEETINGPLACE_TAG_CONTENTFUL_ID || '';

  const { unityProvider, loadingProgression, isLoaded } = useUnityContext({
    loaderUrl: buildUrl(storageUrl, node_locale, meetingPlaceId, 'loader.js'),
    dataUrl: buildUrl(storageUrl, node_locale, meetingPlaceId, 'data.unityweb'),
    frameworkUrl: buildUrl(
      storageUrl,
      node_locale,
      meetingPlaceId,
      'framework.js.unityweb',
    ),
    codeUrl: buildUrl(storageUrl, node_locale, meetingPlaceId, 'wasm.unityweb'),
  });

  const handleUnityClick = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({ event: 'click_to_napping_widget' });
    }
  };

  return (
    <>
      {!isLoaded && <SkeletonLoader />}
      <div
        onClick={handleUnityClick}
        style={{ display: isLoaded ? 'block' : 'none' }}
      >
        <Unity
          unityProvider={unityProvider}
          style={{
            width: '100%',
            height: 'auto',
            aspectRatio: '0.75/1',
            borderRadius: '20px',
            marginBottom: '20px',
          }}
        />
      </div>
    </>
  );
};
